module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CCT2",
    attrs: {
      "id": "c_pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Prologue:")]), _vm._v(" Why I Wrote This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.")]), _vm._v(" A Brief Introduction to the Morality of Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch1_sec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec1"
    }
  }, [_vm._v("The Prevalence of Deceit")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch1_sec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec2"
    }
  }, [_vm._v("Sometimes We Ought to Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch1_sec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec3"
    }
  }, [_vm._v("One Should Never Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch1_sec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec4"
    }
  }, [_vm._v("The Moral Complexity of Truthfulness and Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch1_sec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec5"
    }
  }, [_vm._v("The Paradox of Self-Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2.")]), _vm._v(" Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lite-Brites and Magic Lanterns")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love and Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Children Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Teach Your Child to Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cartwheeling Up Mount Olympus")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crying Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How I Became a Real Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch2_sec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Separation Anxiety and Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("3.")]), _vm._v(" First Loves")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parent as First Lover")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa’s Hair")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The L Word")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turgenev’s “First Love”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love as Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Deception and Bad Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Young Werther as First Lover")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing to Fall in Love")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Joyce on First Love")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Young Simone de Beauvoir")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Liars")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Cousin Anna")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twisted Self-Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch3_sec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onanism")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("4.")]), _vm._v(" Erotic Love")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex on a Bet")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parenthesis on Kissing")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back to My Love Story: A Rival and Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex and Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don Juan and the Cuttlefish")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theory of Falling in Love")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creative Crystallization")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shakespeare on Seduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proust, Seduction, and Heartbreak")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love’s Autopsy")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch4_sec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Erotic Sociopath")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("5.")]), _vm._v(" Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage and Suicide")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Premonition")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adultery for Adults")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drunks and Cheaters")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Time’s the Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Am I Just Addicted to Marriage?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Traditional Model and the Cure")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marriage Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Violence of Creating the Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1",
    attrs: {
      "id": "ch5_sec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage for Grown-Ups")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_Toc_Link7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#Toc_Link7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_Toc_Link8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#Toc_Link8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#also",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Clancy Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0